import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  appMaintenanceStatusSubject$: Subject<string> = new Subject<string>();

  // Bridge for publishing logic to avoid duplication
  private publishActionSource = new Subject<{ type: string; data?: any }>();
  publishAction$ = this.publishActionSource.asObservable();

  private logoutActionSource = new Subject();
  logoutAction$ = this.logoutActionSource.asObservable();

  // Shared publishing state
  showProgressBar$ = new BehaviorSubject<boolean>(false);
  publishProgress$ = new BehaviorSubject<number>(0);
  lastPublishData$ = new BehaviorSubject<any>({});

  // Bridge for toggling chat
  private toggleChatSource = new Subject<void>();
  toggleChat$ = this.toggleChatSource.asObservable();

  isChatCollapsed$ = new BehaviorSubject<boolean>(false);
  activeArtifactTab$ = new BehaviorSubject<string>('blueprint');
  lastArtifactRoute: string | null = null;
  gitPushHappened$ = new BehaviorSubject<boolean>(false);

  private navigateHomeSource = new Subject<void>();
  navigateHome$ = this.navigateHomeSource.asObservable();

  constructor() {
    // Injectable services can have empty constructors
  }

  triggerNavigateHome() {
    this.navigateHomeSource.next();
  }

  triggerPublish(type: string, data?: any) {
    this.publishActionSource.next({ type, data });
  }

  triggerLogout() {
    this.logoutActionSource.next({});
  }

  private createNewSessionSource = new Subject<void>();
  createNewSession$ = this.createNewSessionSource.asObservable();

  isNewSessionActive$ = new BehaviorSubject<boolean>(false);

  triggerCreateNewSession() {
    this.createNewSessionSource.next();
  }

  setNewSessionActiveState(isActive: boolean) {
    this.isNewSessionActive$.next(isActive);
  }

  private openSessionsSource = new Subject<void>();
  openSessions$ = this.openSessionsSource.asObservable();

  isSessionsPanelOpen$ = new BehaviorSubject<boolean>(false);

  triggerOpenSessions() {
    this.openSessionsSource.next();
  }

  setSessionsPanelState(isOpen: boolean) {
    this.isSessionsPanelOpen$.next(isOpen);
  }

  triggerToggleChat() {
    this.toggleChatSource.next();
  }

  setChatCollapsedState(isCollapsed: boolean) {
    this.isChatCollapsed$.next(isCollapsed);
  }

  updateProgress(show: boolean, value: number) {
    this.showProgressBar$.next(show);
    this.publishProgress$.next(value);
  }

  updateLastPublishData(data: any) {
    this.lastPublishData$.next(data);
  }

  getAppMaintenanceStatusSubject(): Subject<string> {
    return this.appMaintenanceStatusSubject$;
  }

  emitAppMaintenanceStatus(status: string): void {
    this.appMaintenanceStatusSubject$.next(status);
  }

  completeAppMaintenanceStatusSubject(): void {
    this.appMaintenanceStatusSubject$.complete();
  }
}
